export const accountTypes = {
  ACCOUNT_TYPE_COURT_REPORTING_AGENCY: 'Court Reporting Agency',
  ACCOUNT_TYPE_TRANSCRIPTION_SERVICE_PROVIDER: 'Transcription Service Provider',
  ACCOUNT_TYPE_COURT_REPORTER: 'Court Reporter',
  ACCOUNT_TYPE_LEGAL_PROFESSIONAL: 'Legal Professional',
  ACCOUNT_TYPE_OTHER: 'Other',
};
